export default __webpack_public_path__ + "static/monster3-9f7800d91b7b89c34d8122a9d2c8505e.png";